import React, { type ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import isAdmin from '../helpers/isAdmin';

type RootState = { login: { role: string | null } };

export default function RequireAdmin({ children }: { children: ReactElement }): ReactElement | null {
  const role = useSelector((state: RootState) => state.login.role);

  // AuthLayout fetches the user asynchronously, so role is null until it lands.
  // Redirecting on null would bounce an admin who hard-refreshes onto this route.
  if (role === null) return null;

  return isAdmin(role) ? children : <Navigate to="/" replace />;
}
